import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DialogModule } from '@progress/kendo-angular-dialog';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';

import { PipesModule } from '../pipes/pipes.module';
import { CgpFormDialogComponent } from './cgp-form-dialog.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { SortableModule } from '@progress/kendo-angular-sortable';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { UploadModule } from '@progress/kendo-angular-upload';
import { PanelBarModule } from '@progress/kendo-angular-layout';
// import { CgpFormDialogService } from './cgp-form-dialog.service';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SwitchModule,
        NumericTextBoxModule,
        AutoCompleteModule,
        MultiSelectModule,
        ComboBoxModule,
        DropDownListModule,
        DialogModule,
        PipesModule,
        DateInputsModule,
        SortableModule,
        ButtonsModule,
        UploadModule,
        PanelBarModule
    ],
    declarations: [
        CgpFormDialogComponent,
    ],
    exports: [
        CgpFormDialogComponent
    ],
    providers: [
    // CgpFormDialogService
    ]
})
export class CgpFormDialogModule { }
